//Custom components

//Services

import Card from '@/components/UI/Card/index.tsx';
import QuestionMarkTooltip from '@/components/UI/QuestionMarkTooltip';

//Assets and miscellaneous

//appending CCLF Project statuses to avoid disruption

const ProjectStatusSummary = ({ projectStatus }: any) => {
  return (
    <Card title='Project Status Summary'>
      <div className='h-96 overflow-scroll'>
        {projectStatus?.map((s: any) => (
          <div key={s?.status} className='relative flex justify-between py-5 px-10 border-b'>
            <div className='flex items-center gap-2 text-grey-700 w-full relative'>
              <span>{s?.status}</span>
              <span className='relative'>
                <QuestionMarkTooltip toolTip={s?.status} />
              </span>
            </div>
            <span className='text-xl font-bold'>{s._count}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ProjectStatusSummary;
